package anjuros.development.sections

import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import anjuros.development.components.Header
import anjuros.development.components.RoomZoomView
import anjuros.development.components.language.LocalText
import anjuros.development.components.language.ResKey
import anjuros.development.modules.Theme
import anjuros.development.util.Constants
import anjuros.development.util.Constants.SECTION_WIDTH
import anjuros.development.util.ContactButtonStyle
import anjuros.development.util.ContactMeDetailsFontStyle
import anjuros.development.util.Res
import anjuros.development.util.rememberOrientation
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.ObjectFit
import com.varabyte.kobweb.compose.css.TextAlign
import com.varabyte.kobweb.compose.css.TextDecorationLine
import com.varabyte.kobweb.compose.css.Transition
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.cursor
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxHeight
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxSize
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.fontFamily
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.id
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.maxHeight
import com.varabyte.kobweb.compose.ui.modifiers.maxWidth
import com.varabyte.kobweb.compose.ui.modifiers.objectFit
import com.varabyte.kobweb.compose.ui.modifiers.onClick
import com.varabyte.kobweb.compose.ui.modifiers.textAlign
import com.varabyte.kobweb.compose.ui.modifiers.textDecorationLine
import com.varabyte.kobweb.compose.ui.modifiers.transition
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.components.graphics.Image
import com.varabyte.kobweb.silk.components.navigation.Link
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.style.breakpoint.displayIfAtLeast
import com.varabyte.kobweb.silk.style.breakpoint.displayUntil
import com.varabyte.kobweb.silk.style.toModifier
import org.jetbrains.compose.web.css.ms
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.P
import org.jetbrains.compose.web.dom.Text

@Composable
fun MainSection(onMenuClosed: () -> Unit) {
    var zoomClicked by remember { mutableStateOf(false) }
    val isLandscape  by  rememberOrientation()

    Box(
        modifier = Modifier
            .id("home")
            .fillMaxWidth()
            .maxWidth(SECTION_WIDTH.px),
        contentAlignment = Alignment.Center
    ) {
        Column(
            modifier = Modifier.fillMaxSize(),
            horizontalAlignment = Alignment.CenterHorizontally
        ) {
            Header() { onMenuClosed() }
            About(
                isLandscape = isLandscape,
                { zoomClicked = true }
            )
        }
        PhotosZoom(
            zoomClicked,
            { zoomClicked = false })
    }
}

@Composable
fun About(
    isLandscape: Boolean,
    onImageClicked:()->Unit
) {

    Row(
        modifier = Modifier
            .fillMaxWidth()
            .displayIfAtLeast(Breakpoint.LG)
            .height(500.px)
            .backgroundColor(Theme.Primary.rgb),
        verticalAlignment = Alignment.CenterVertically,
        horizontalArrangement = Arrangement.SpaceEvenly
    ) {
        DetailsInformation(
            modifier = Modifier
                .height(500.px)
        )
        Image(
            modifier = Modifier
                .fillMaxWidth(50.percent)
                .fillMaxHeight(90.percent)
                .onClick { onImageClicked() }
                .cursor(Cursor.Pointer)
                .margin(right = 30.px)
                .objectFit(ObjectFit.ScaleDown),
            src = Res.Image.about_image,
            alt = "Noclegi w pobliżu Białki Tatrzańskiej"
        )
    }


        Column(
            modifier = Modifier
                .displayUntil(Breakpoint.LG)
                .fillMaxWidth()

                .backgroundColor(Theme.Primary.rgb),
            horizontalAlignment = Alignment.CenterHorizontally,
            verticalArrangement = Arrangement.SpaceEvenly
        ) {
            DetailsInformation(
                modifier = Modifier
                    .height(200.px)
            )
            Image(
                modifier = Modifier
                    .onClick { onImageClicked() }
                    .cursor(Cursor.Pointer)
                    .height(200.px)
                    .margin(bottom = 10.px)
                    .objectFit(ObjectFit.ScaleDown),
                src = Res.Image.about_image,
                alt = "Noclegi w pobliżu Białki Tatrzańskiej"
            )
        }
}

@Composable
fun CompanyName(modifier: Modifier){
    P(
        attrs = modifier
            .transition(
                Transition.of(
                    "margin", 1100.ms,
                    delay = 300.ms
                )
            )
            .fontFamily(Constants.FONT_DANICNINGSCRIPT)
            .fontSize(46.px)
            .color(Colors.White)
            //.fontWeight(FontWeight.Normal)
            .toAttrs()
    ) {
        Text(Constants.CLIENTS_COMPANY)

    }
}

@Composable
fun DetailsInformation(modifier: Modifier) {
    Box(
        modifier = modifier
            .fillMaxWidth()
            .height(500.px)
    ) {


        CompanyName(
            modifier = ContactMeDetailsFontStyle.toModifier()
                .displayIfAtLeast(Breakpoint.LG)
                .margin(top = 50.px)
                .align(Alignment.TopCenter)
        )

        Row(
            modifier = Modifier.fillMaxWidth()
                .displayIfAtLeast(Breakpoint.LG)
                .align(Alignment.Center),
            verticalAlignment = Alignment.CenterVertically,
            horizontalArrangement = Arrangement.SpaceAround
        ) {

            PhonesInformation(
                modifier.fillMaxWidth(50.percent)

            )
            AddressInformation(
                modifier.fillMaxWidth(50.percent)
                    .margin(top = 30.px)
            )
        }

        Column(
            modifier = Modifier.fillMaxWidth()
                .maxHeight(500.px)
                .displayUntil(Breakpoint.LG)
                .margin(top = 70.px)
                .align(Alignment.Center),
            horizontalAlignment = Alignment.CenterHorizontally,
            verticalArrangement = Arrangement.SpaceAround
        ) {
            CompanyName(
                modifier = ContactMeDetailsFontStyle.toModifier()
                    .displayUntil(Breakpoint.LG)
                    .margin(top = 30.px)
                    .margin()

            )
            PhonesInformation(
                modifier.fillMaxWidth()

            )
            AddressInformation(
                modifier.fillMaxWidth()

            )
        }
    }
}

@Composable
fun PhotosZoom(
    zoomClicked: Boolean,
    onExitClicked: () -> Unit
) {
    var imageZoomedIndex by remember { mutableStateOf(0) }
    val allImages = listOf(
        Res.Image.about_image,
        Res.Image.room1_2,
        Res.Image.room3_4,
        Res.Image.hotel1,
        Res.Image.room2_1,
        Res.Image.hotel3,
        Res.Image.room2_5,
        Res.Image.room1_5,
        Res.Image.room3_1,
        Res.Image.hotel5,
        Res.Image.room2_3,
        Res.Image.room1_1,
        Res.Image.room3_5,
        Res.Image.hotel2,
        Res.Image.room2_4,
        Res.Image.room1_3,
        Res.Image.room3_2,
        Res.Image.hotel4,
        Res.Image.room1_4,
        Res.Image.room2_2,
        Res.Image.room3_3
    )

    if (zoomClicked) {

        RoomZoomView(
            modifier = Modifier,
            allImages[imageZoomedIndex],
            onLeftClicked = {
                imageZoomedIndex--
                if (imageZoomedIndex == -1) {
                    imageZoomedIndex = allImages.size - 1
                }
            },
            onRightClicked = {
                imageZoomedIndex++
                if (imageZoomedIndex >= allImages.size) {
                    imageZoomedIndex = 0
                }
            },
            onExitClicked = {
                onExitClicked()
            })
    }
}

@Composable
fun AddressInformation( modifier: Modifier) {
    Column(
        modifier = modifier,
        horizontalAlignment = Alignment.CenterHorizontally,
        verticalArrangement = Arrangement.Center
    ) {
        Box(
            modifier = Modifier
                .margin(bottom = 30.px)
        ) {
            Image(
                modifier = Modifier
                    .height(80.px)
                    .objectFit(ObjectFit.ScaleDown),
                src = Res.Image.map,
                alt = "Noclegi w pobliżu Kotelnicy"
            )
            Box(
                modifier = ContactButtonStyle.toModifier()
                    .align(Alignment.Center)
                    .backgroundColor(Theme.Primary.rgb)
                    .borderRadius(5.px)
            ) {
                Link(
                    path = Constants.CLIENTS_MAP,
                    modifier = Modifier
                        .textDecorationLine(TextDecorationLine.None)
                        .align(Alignment.Center)

                ) {
                    P(
                        attrs = Modifier
                            .margin(5.px)
                            .align(Alignment.Center)
                            .fontFamily(Constants.FONT_FAMILY)
                            .color(Colors.White)
                            .fontSize(18.px)
                            .fontWeight(FontWeight.Normal)
                            .toAttrs()
                    ) {
                        Text(LocalText(ResKey.MAP_DIRECTION))
                    }
                }
            }
        }
        P(
            attrs = ContactMeDetailsFontStyle.toModifier()

                .margin(topBottom = 0.px)
                .transition(
                    Transition.of(
                        "margin", 900.ms,
                        delay = 500.ms
                    )
                )

                .fontFamily(Constants.FONT_FAMILY)
                .color(Colors.White)
                .fontSize(18.px)
                .fontWeight(FontWeight.Normal)
                .toAttrs()
        ) {
            Text(Constants.CLIENTS_ADDRESS)

        }
        P(
            attrs = ContactMeDetailsFontStyle.toModifier()

                .margin(topBottom = 0.px)
                .fontFamily(Constants.FONT_FAMILY)
                .color(Colors.White)
                .textAlign(TextAlign.Center)
                .fontSize(18.px)
                .fontWeight(FontWeight.Normal)
                .toAttrs()
        ) {
            Text(LocalText(ResKey.ADDRESS))

        }
    }
}

@Composable
fun PhonesInformation(
    modifier: Modifier
) {


    Column(
        modifier = modifier,
        horizontalAlignment = Alignment.CenterHorizontally,
        verticalArrangement = Arrangement.Center
    ) {
        Link(
            path = "tel:${Constants.CLIENTS_PHONE}",
            modifier = Modifier.textDecorationLine(TextDecorationLine.None)
                .margin(bottom = 2.px)
        ) {
            P(
                attrs = ContactMeDetailsFontStyle.toModifier()

                    .margin(topBottom = 0.px)

                    .fontFamily(Constants.FONT_FAMILY)
                    .color(Colors.White)
                    .fontWeight(FontWeight.Bold)
                    .toAttrs()
            ) {
                Text(Constants.CLIENTS_PHONE)

            }
        }
        Link(
            path = "tel:${Constants.CLIENTS_PHONE2}",
            modifier = Modifier.textDecorationLine(TextDecorationLine.None)
                .margin(top = 2.px)
        ) {
            P(
                attrs = ContactMeDetailsFontStyle.toModifier()

                    .margin(topBottom = 0.px)

                    .fontFamily(Constants.FONT_FAMILY)
                    .color(Colors.White)
                    .fontWeight(FontWeight.Bold)
                    .toAttrs()
            ) {
                Text(Constants.CLIENTS_PHONE2)

            }
        }
        Box(
            modifier = ContactButtonStyle.toModifier()
                .margin(top = 30.px)
                .backgroundColor(Colors.White)
                .borderRadius(5.px)
        ) {
            Link(
                path = Constants.CLIENTS_BOOKING,
                modifier = Modifier
                    .textDecorationLine(TextDecorationLine.None)
                    .align(Alignment.Center)

            ) {
                P(
                    attrs = Modifier
                        .margin(5.px)
                        .align(Alignment.Center)
                        .fontFamily(Constants.FONT_FAMILY)
                        .color(Theme.Primary.rgb)
                        .fontSize(20.px)
                        .fontWeight(FontWeight.Bold)
                        .toAttrs()
                ) {
                    Text(LocalText(ResKey.BOOKING))
                }
            }
        }
    }
}
